export const POSTHOG_KEY = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST;
export const HUBSPOT_TRACKING_ID = import.meta.env.VITE_HUBSPOT_ID;
